import { getState } from './state';
export function getMessageState(state, messageId) {
    const slice = getState(state).messageState || {};
    return slice[messageId] || {};
}
